import { SxProps, Theme, Typography, styled } from "@mui/material"

export const TypographyHead = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  color: theme.palette.primary.main,
  textTransform: "uppercase",
}))

export const visuallyHiddenSx: SxProps<Theme> = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0,
}
